import React, { useEffect, useState, useRef } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Table,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";


import axiosInstance from "../../axiosInstance";
import { URL } from "../../api.jsx";
import { Toast, ToastBody } from "reactstrap";



const CallerAddGetRemarks = () => {
  const callerId = localStorage.getItem("userId");
  const callerName = localStorage.getItem("username");

  /* -------------------- STATES -------------------- */
  const [counts, setCounts] = useState({});
  const [countss, setCountss] = useState({});
  const [remarks, setRemarks] = useState([]);
  const [dispositions, setDispositions] = useState([]);
  const [toast, setToast] = useState(false);
  const [ptpLoading, setPtpLoading] = useState(false);
  const [remarkLoading, setRemarkLoading] = useState(false);




  const [customerId, setCustomerId] = useState("");
  const [page, setPage] = useState(0);
  const [size] = useState(10);

  const [loading, setLoading] = useState(false);

  // PTP POPUP
const [showPtpModal, setShowPtpModal] = useState(false);
const [ptpForm, setPtpForm] = useState({
  paymentType: "PARTIAL",
  promisedPayDate: "",
  promisedAmount: ""
});


  /* ADD REMARKS */
  const [showAdd, setShowAdd] = useState(false);
  const [form, setForm] = useState({
    customerId: "",
    dispositionStatusValue: "",
    remarks: "",
  });

  /* -------------------- API CALLS -------------------- */

  const fetchTotalCalls = async () => {
  const res = await axiosInstance.get(URL.CALL_COUNT);
  setCountss(res.data || {});
};


  // CALLER COUNT TILL NOW
  const fetchCallerCounts = async () => {
    const res = await axiosInstance.get(URL.CALLER_CALL_COUNT, {
      params: { callerId },
    });
    setCounts((prev) => ({
      ...prev,
      count: res.data?.count ?? 0,
    }));
  };

  // // ✅ GET REMARKS LIST (conditional callerId filter)
  // const fetchRemarks = async (pageNo = 0) => {
  //   try {
  //     setLoading(true);
  //     const res = await axiosInstance.get("/call-remarks/list", {
  //       params: {
  //         customerId: customerId || null,
  //         callerId: customerId ? null : callerId, // ⭐ KEY CHANGE
  //         page: pageNo,
  //         size,
  //       },
  //     });
  //     setRemarks(res.data || []);
  //     setPage(pageNo);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchRemarks = async (pageNo = 0) => {
  try {
    setLoading(true);
    const res = await axiosInstance.get(URL.CALL_REMARKS_LIST, {
      params: {
        customerId: customerId || null,
        callerId: customerId ? null : callerId,
        page: pageNo,
        size,
      },
    });
    setRemarks(res.data || []);
    setPage(pageNo);
  } finally {
    setLoading(false);
  }
};

  // GET DISPOSITION DROPDOWN
  const fetchDispositions = async () => {
    const res = await axiosInstance.get(URL.GET_CODES_DISPOSITION);
    setDispositions(res.data || []);
  };


const submitRemark = async () => {
  if (remarkLoading) return;   // extra safety

  // If disposition = 18 (Promise To Pay), open popup
  if (Number(form.dispositionStatusValue) === 18) {
    setShowPtpModal(true);
    return;
  }

  try {
    setRemarkLoading(true);

    await axiosInstance.post(URL.ADD_REMARKS, {
      customerId: form.customerId,
      callerId,
      dispositionStatusValue: form.dispositionStatusValue,
      remarks: form.remarks,
    });

    setToast(true);
    setTimeout(() => setToast(false), 3000);

    setShowAdd(false);
    setForm({ customerId: "", dispositionStatusValue: "", remarks: "" });

    fetchRemarks(0);
    fetchCallerCounts();
    fetchTotalCalls();

  } catch (error) {
    console.error(error);
  } finally {
    setRemarkLoading(false);
  }
};


const submitPtpAndRemark = async () => {
  if (ptpLoading) return;   // extra safety

  try {
    setPtpLoading(true);

    // 1️⃣ Call PTP API
    await axiosInstance.post(URL.GENERATE_PTP, {
      customerId: Number(form.customerId),
      callerId: Number(callerId),
      dispositionStatusValue: 18,
      promisedPayDate: ptpForm.promisedPayDate,
      promisedAmount: ptpForm.promisedAmount,
      paymentType: ptpForm.paymentType,
      remarks: form.remarks
    });

    // 2️⃣ Call ADD REMARKS API
    await axiosInstance.post(URL.ADD_REMARKS, {
      customerId: form.customerId,
      callerId,
      dispositionStatusValue: form.dispositionStatusValue,
      remarks: form.remarks,
    });

    setToast(true);
    setTimeout(() => setToast(false), 3000);

    setShowPtpModal(false);
    setShowAdd(false);

    setForm({ customerId: "", dispositionStatusValue: "", remarks: "" });
    setPtpForm({ paymentType: "PARTIAL", promisedPayDate: "", promisedAmount: "" });

    fetchRemarks(0);
    fetchCallerCounts();
    fetchTotalCalls();

  } catch (error) {
    console.error(error);
  } finally {
    setPtpLoading(false);
  }
};

  /* -------------------- INIT -------------------- */
  const initRef = useRef(false);

  useEffect(() => {
    if (initRef.current) return;
    initRef.current = true;

    fetchTotalCalls();       // ✅ new
    fetchCallerCounts();
    fetchDispositions();
    fetchRemarks(0);
  }, []);


  return (
    <>
   {/* ================= TOP CARDS ================= */}
<Row className="g-3 mb-4">
  <Col md="6">
    <Card className="h-100 bg-dark text-white">
      <CardBody>
        <h6>Total Calls</h6>
        <h2>{countss.total_calls_till_today ?? 0}</h2>
      </CardBody>
    </Card>
  </Col>

  <Col md="6">
    <Card className="h-100 bg-dark text-white">
      <CardBody>
        <h6>Total Caller Calls</h6>
        <h2>{counts.count ?? 0}</h2>
      </CardBody>
    </Card>
  </Col>
</Row>

      {/* ================= FILTER BAR ================= */}
      <Card className="mb-3">
        <CardBody>
  <div className="d-flex gap-2 align-items-end flex-wrap">

    {/* FILTER TYPE (static for now) */}
    <div>
      <label className="form-label mb-1">Filter Type</label>
      <select className="form-select form-select-sm" disabled>
        <option>Customer ID</option>
      </select>
    </div>

    {/* FILTER VALUE */}
    <div>
      <label className="form-label mb-1">Customer ID</label>
      <Input
        bsSize="sm"
        value={customerId}
        onChange={(e) => setCustomerId(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") fetchRemarks(0);
        }}
        style={{ width: 180 }}
      />
    </div>

    {/* SEARCH */}
    <Button size="sm" color="info" onClick={() => fetchRemarks(0)}>
      Search
    </Button>

    {/* RESET */}
    <Button
      size="sm"
      color="secondary"
      onClick={() => {
        setCustomerId("");
        fetchRemarks(0);
      }}
    >
      Reset
    </Button>

    {/* ADD REMARKS */}
    <Button
      size="sm"
      color={showAdd ? "secondary" : "success"}
      onClick={() => setShowAdd((prev) => !prev)}
    >
      {showAdd ? "− Close Remarks" : "+ Add Remarks"}
    </Button>

  </div>
</CardBody>
      </Card>

      {/* ================= ADD REMARK FORM ================= */}
      {showAdd && (
        <Card className="mb-3">
          <CardBody>
            <Row className="g-2">
              <Col md="3">
                <Input
                  placeholder="Customer ID"
                  value={form.customerId}
                  onChange={(e) =>
                    setForm({ ...form, customerId: e.target.value })
                  }
                />
              </Col>

              <Col md="3">
                <Input
                  type="select"
                  value={form.dispositionStatusValue}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      dispositionStatusValue: e.target.value,
                    })
                  }
                >
                  <option value="">Select Disposition</option>
                  {dispositions.map((d) => (
                    <option key={d.id} value={d.statusValue}>
                      {d.statusFullName}
                    </option>
                  ))}
                </Input>
              </Col>

              <Col md="4">
                <Input
                  placeholder="Remarks"
                  value={form.remarks}
                  onChange={(e) =>
                    setForm({ ...form, remarks: e.target.value })
                  }
                />
              </Col>



              <Col md="2">
               <Button 
  color="primary" 
  onClick={submitRemark}
  disabled={remarkLoading}
>
  {remarkLoading ? <Spinner size="sm" /> : "Save"}
</Button>

              </Col>
            </Row>
          </CardBody>
        </Card>
      )}

      {/* ================= REMARKS TABLE ================= */}
      <Card>
        <CardBody>
          {loading ? (
            <Spinner />
          ) : (
            <Table bordered hover size="sm">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Customer</th>
                  <th>Caller Name</th>
                  <th>Disposition</th>
                  <th>Code</th>
                  <th>Remarks</th>
                  <th>Call Date Time</th>
                </tr>
              </thead>
              <tbody>
                {remarks.map((r) => (
                  <tr key={r.id}>
                    <td>{r.id}</td>
                    <td>{r.customer_id}</td>
                    <td>{r.caller_name}</td>
                    <td>{r.status_full_name}</td>
                    <td>{r.disposition_code}</td>
                    <td>{r.remarks}</td>
                    <td>{r.call_datetime}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}

          {/* PAGINATION */}
          <div className="d-flex justify-content-end gap-2">
            <Button
              size="sm"
              disabled={page === 0}
              onClick={() => fetchRemarks(page - 1)}
            >
              Prev
            </Button>

             <span className="align-self-center">
            Page {page + 1}
             </span>

            <Button size="sm" onClick={() => fetchRemarks(page + 1)}>
              Next
            </Button>
          </div>
        </CardBody>
        {/* ================= TOAST ================= */}
<div
  style={{
    position: "fixed",
    top: 20,
    right: 20,
    zIndex: 9999,
  }}
>
  <Toast isOpen={toast}>
    <ToastBody className="bg-success text-white rounded">
      ✅ Remarks added successfully
    </ToastBody>
  </Toast>
</div>

      </Card>
      <Modal isOpen={showPtpModal} toggle={() => setShowPtpModal(false)}>
  <ModalHeader toggle={() => setShowPtpModal(false)}>
    Promise To Pay
  </ModalHeader>

  <ModalBody>
    <Row className="g-2">
      <Col md="12">
        <label>Payment Type</label>
        <Input
          type="select"
          value={ptpForm.paymentType}
          onChange={(e) =>
            setPtpForm({ ...ptpForm, paymentType: e.target.value })
          }
        >
          <option value="PARTIAL">PARTIAL</option>
          <option value="FULL">FULL</option>
        </Input>
      </Col>

      <Col md="12">
        <label>Promised Pay Date</label>
        <Input
          type="date"
          value={ptpForm.promisedPayDate}
          onChange={(e) =>
            setPtpForm({ ...ptpForm, promisedPayDate: e.target.value })
          }
        />
      </Col>

      <Col md="12">
        <label>Promised Amount</label>
        <Input
          type="number"
          value={ptpForm.promisedAmount}
          onChange={(e) =>
            setPtpForm({ ...ptpForm, promisedAmount: e.target.value })
          }
        />
      </Col>
    </Row>
  </ModalBody>

  <ModalFooter>
    <Button 
  color="primary" 
  onClick={submitPtpAndRemark}
  disabled={ptpLoading}
>
  {ptpLoading ? <Spinner size="sm" /> : "Confirm"}
</Button>

  </ModalFooter>
</Modal>

    </>
    
    
  );
};

export default CallerAddGetRemarks;
